import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../../services/auth';
import AppLayout from '../../../../components/layout/AppLayout/AppLayout.jsx';
import './Dashboard.css';

const Dashboard = ({ onLogout }) => {
  const { t } = useTranslation(['dashboard', 'common']);
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const [error, setError] = useState('');

  const handleNavigateToUsers = () => {
    navigate('/users');
  };

  const handleNavigateToInventory = () => {
    navigate('/inventory');
  };

  const modules = [
    {
      title: `👥 ${t('dashboard:modules.users.title')}`,
      description: t('dashboard:modules.users.description'),
      buttonText: t('dashboard:modules.users.button'),
      buttonClass: 'primary',
      adminOnly: true,
      onClick: handleNavigateToUsers
    },
    {
      title: `📦 ${t('dashboard:modules.inventory.title')}`,
      description: t('dashboard:modules.inventory.description'),
      buttonText: t('dashboard:modules.inventory.button'),
      buttonClass: 'success',
      adminOnly: false,
      onClick: handleNavigateToInventory
    },
    {
      title: `📋 ${t('dashboard:modules.transactions.title')}`,
      description: t('dashboard:modules.transactions.description'),
      buttonText: t('dashboard:modules.transactions.button'),
      buttonClass: 'purple',
      adminOnly: false,
      onClick: () => alert(t('dashboard:modules.transactions.title') + ' functionality coming soon!')
    },
    {
      title: `🚨 ${t('dashboard:modules.alerts.title')}`,
      description: t('dashboard:modules.alerts.description'),
      buttonText: t('dashboard:modules.alerts.button'),
      buttonClass: 'warning',
      adminOnly: false,
      onClick: () => alert(t('dashboard:modules.alerts.title') + ' functionality coming soon!')
    },
    {
      title: `📊 ${t('dashboard:modules.reports.title')}`,
      description: t('dashboard:modules.reports.description'),
      buttonText: t('dashboard:modules.reports.button'),
      buttonClass: 'info',
      adminOnly: false,
      onClick: () => alert(t('dashboard:modules.reports.title') + ' functionality coming soon!')
    }
  ];

  const filteredModules = modules.filter(module => 
    !module.adminOnly || (module.adminOnly && user?.role === 'admin')
  );

  return (
    <AppLayout 
      title={t('dashboard:title')}
      error={error}
      setError={setError}
      onLogout={onLogout}
    >
      <div className="dashboard-content">
        <div className="modules-grid">
          {filteredModules.map((module, index) => (
            <div key={index} className="module-card">
              <h3 className="module-title">
                {module.title}
              </h3>
              <p className="module-description">
                {module.description}
              </p>
              <button 
                onClick={module.onClick}
                className={`module-button ${module.buttonClass}`}
              >
                {module.buttonText}
              </button>
            </div>
          ))}
        </div>

        <div className="status-card success">
          <h4 className="status-card-title">🎉 {t('dashboard:status.system_status')}</h4>
          <p>
            {t('dashboard:status.system_operational')}
          </p>
        </div>

        <div className="status-card warning">
          <h4 className="status-card-title">🚀 {t('dashboard:status.next_steps')}</h4>
          <ul>
            <li>{t('dashboard:status.setup_categories')}</li>
            <li>{t('dashboard:status.configure_alerts')}</li>
            <li>{t('dashboard:status.import_data')}</li>
            <li>{t('dashboard:status.create_accounts')}</li>
          </ul>
        </div>
      </div>
    </AppLayout>
  );
};

export default Dashboard;